<div class="container">
  <div class="icon">&#10004;</div>
  <h1>Payment Successful!</h1>
  <p>Thank you for your purchase. Your transaction has been completed successfully.</p>
  <!--<div class="transaction-details">
            <p><strong>Transaction ID:</strong> 123456789</p>
            <p><strong>Amount Paid:</strong> $50.00</p>
            <p><strong>Date:</strong> November 10, 2025</p>
        </div>
        <div class="actions">
            <a href="#" class="button">Continue Shopping</a>
            <a href="#" class="button">View Receipt</a>
        </div>-->
</div>
